frontApp.lazyLoad = {
  name: 'lazyLoad',
  description: 'vanilla-lazyload',
  init() {
    frontApp.lazyLoadGlobalInstance = new LazyLoad({
      elements_selector: '.js-lazy-load',
      threshold: 100,
      callback_loaded(element) {
        element.parentNode.classList.add('child-loaded');
      },
      callback_enter(element) {
        element.parentNode.classList.add('child-loaded');
      },
    });
  },
};
